import { render, staticRenderFns } from "./StepOtp.vue?vue&type=template&id=c0ea30ba&scoped=true"
import script from "./StepOtp.vue?vue&type=script&lang=js"
export * from "./StepOtp.vue?vue&type=script&lang=js"
import style0 from "./StepOtp.vue?vue&type=style&index=0&id=c0ea30ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ea30ba",
  null
  
)

export default component.exports